var _circle, _circle2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKakao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#FEE500"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 10,
    fill: "url(#pattern0_2218_7975)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_2218_7975",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2218_7975",
    transform: "scale(0.0277778)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2218_7975",
    width: 36,
    height: 36,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB9UlEQVRYhe3YvWsUQRjH8c/mDVTs7BTSpLQQbUSClhJLK5VYCIKpBBv/AzstxViINmJrpYWSxhiuSusbCBG8Si2UGDCJa7Fzsq6zd7u528sV+cGw7DO783yZ59mZZzZJ09QoaWy3AYraA+qlifxNkiR13p3EDI5gH7bxLbSP2Kw6UD6PJ7o8F9M0zuMUjgeQmDawimU8xVpVB0merssMzeAmzqkf5t94hltlYP8w9AAaw3XckIWoH23gNu4HyNpAk1jEXJ8gRT3HglyO5RnKpj9pCEYYczH4+E9lQAsNwXQ0h2uxjljIDqGF/Q0CwU+cxJdeIZsfAozgY75ojAGdbZ6l3FcsZGv6/8SrahPT3UJ2YIgwgq+DeUMRaF2NPWgA2sKPvCGWQ++GwwI+FA0xoKUhgHT0omiIJfVhvMZUwzC/ZFVDu9c69Bn3GoaBu2gXjWWb6zieYLYhmGVckiV1pc11G1ew0gBMC1c7MEV1K7bWcREPMIizUoqHuIDvZQ9VrRhPyErR8R3CrMiKs1ascyc19XpNmFS2xrzCY7yt+mJVoNMl9vd4FMbpnDq+4k241lZVoDOF+y3Z0nBHtp4MTmma/m0lmpKds9qhLeFYYwwVgGYDyCfZUWjg1UBdoMt4iaODBokBJV1AdkUj97NhD6iXRg7oD0iYwNZuoFoZAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKakao);
export default __webpack_public_path__ + "static/media/kakao.01fed363d35785df8f78c98c28b9a17a.svg";
export { ForwardRef as ReactComponent };